import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// /feedback and /admin/* render differently per visitor (QR location param, stored admin token),
// so their prerendered HTML can't match the first client render. Render those fresh instead of hydrating.
// /admin/* pages are served from /admin's HTML (see public/_redirects), so they must never hydrate.
const path = window.location.pathname.replace(/\/$/, "");
const clientOnly = path === "/feedback" || path === "/admin" || path.startsWith("/admin/");

if (container.hasChildNodes() && !clientOnly) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  container.replaceChildren();
  ReactDOM.createRoot(container).render(tree);
}
